/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropWithoutWave } from '../models/ApiDropWithoutWave';
import { HttpFile } from '../http/http';

export class ApiReplyToDropResponse {
    'drop_id': string;
    'drop_part_id': number;
    'is_deleted': boolean;
    'drop'?: ApiDropWithoutWave;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "drop_id",
            "baseName": "drop_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "drop_part_id",
            "baseName": "drop_part_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "is_deleted",
            "baseName": "is_deleted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drop",
            "baseName": "drop",
            "type": "ApiDropWithoutWave",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiReplyToDropResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

